import { useEffect } from "react";

import { timer } from "./timer";

export const usePageTimer = (key: string) => {
  const stop = () => {
    const duration = timer.end(key);
    timer.remove(key);

    return duration;
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: deliberately mount-only: the timer starts once per page mount and the isSet guard makes a re-run a no-op. Listing key would restart timing on prop churn.
  useEffect(() => {
    if (timer.isSet(key)) {
      return;
    }

    timer.start(key);
  }, []);

  return {
    stop,
  };
};
